<template>
  <PapeleriaDeliveriesForm :typeEndPoint="'papeleriaDeliveriesShow'" :dataParams="this.$route.params"/>
</template>
<script>
import PapeleriaDeliveriesForm from '@/components/modules/papeleria/deliveries/form'
export default {
  name: 'PapeleriaDeliveriesEdit',
  components: {
    PapeleriaDeliveriesForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/deliveries/edit.vue